import { render, staticRenderFns } from "./IndonesiaFlag.vue?vue&type=template&id=b7456fd0&"
import script from "./IndonesiaFlag.vue?vue&type=script&lang=js&"
export * from "./IndonesiaFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports